import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation, PapiDeviationTier, PapiExtendedDeviation } from '@wix/da-papi-types';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import SubmissionDetails from '../../../SubmissionDetails';
import Stats from '../../../Stats';
import { useScrollToDeviationComments } from '../../../DeviationPage/_partials/Comments/useScrollToDeviationComments';
import JournalTags from '../../Details/_partials/JournalTags';
import Benefit from '../../TierProductCardDumb/Benefit';
import { getTierDescription } from '../../_helpers';

import s from './Tier.scss';

export interface Props {
  deviation: PapiDeviation;
  withArtist?: boolean;
}

const TierContent: React.FC<Props> = ({
  deviation,
  deviation: {
    extended: { tags } = {} as PapiExtendedDeviation,
    tier: { benefits = [], discord } = {} as PapiDeviationTier,
  },
  withArtist = true,
}) => {
  const { t } = useTranslation();
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
  const scrollToDeviationComments = useScrollToDeviationComments();
  const hasDiscord = discord?.connected;

  return (
    <>
      {withArtist && (
        <div className={s['author-block']}>
          <SubmissionDetails deviation={deviation} />
        </div>
      )}
      <div className={s['stats']}>
        <Stats
          deviation={deviation}
          withSubscriberCount
          withViewCount={false}
          withBadges={false}
          onCommentClick={scrollToDeviationComments}
        />
      </div>

      {tags && <JournalTags tags={tags} />}

      {isExtendedLoaded && (
        <div className={s['text-content']}>
          <p className={s['description']}>{getTierDescription(deviation)}</p>

          <ul className={s['benefits']}>
            {hasDiscord && (
              <Benefit
                benefit={t('deviationview.tierCard.benefits.discord')}
                isDiscord
                className={s['benefit']}
              />
            )}
            {benefits.map(benefit => (
              <Benefit key={benefit} benefit={benefit} className={s['benefit']} />
            ))}
          </ul>
        </div>
      )}
    </>
  );
};
TierContent.displayName = 'TierContent';
export default TierContent;
